import PropTypes from 'prop-types';
import cx from 'classnames';
import ConditionalLink from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';
import MaybeWrap from '@plone/volto/components/manage/MaybeWrap/MaybeWrap';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import config from '@plone/volto/registry';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';
import { isInternalURL } from '@plone/volto/helpers/Url/Url';

import DateInfo from '../../../DateInfo';
import DownloadFile from '../../../DownloadFile';

const DefaultTemplate = ({
  items,
  linkTitle,
  linkHref,
  isEditMode,
  showThumbnail = false,
  showDownloadButton = false,
}) => {
  let link = null;
  let href = linkHref?.[0]?.['@id'] || '';

  let Image;

  if (showThumbnail) {
    Image = config.getComponent('Image').component;
  }

  if (isInternalURL(href)) {
    link = (
      <ConditionalLink
        to={flattenToAppURL(href)}
        condition={!isEditMode}
        className="br-item"
      >
        {linkTitle || href}
      </ConditionalLink>
    );
  } else if (href) {
    link = <UniversalLink href={href}>{linkTitle || href}</UniversalLink>;
  }

  return (
    <>
      <div>
        {items.map((item) => {
          const {
            '@id': url,
            '@type': type,
            id,
            title,
            description,
            head_title,
            review_state,
          } = item;

          if (type === 'File' && showDownloadButton) {
            return (
              <div key={url} className="item">
                <DownloadFile item={item} isEditMode={isEditMode} />
              </div>
            );
          }

          return (
            <ConditionalLink
              item={item}
              condition={!isEditMode}
              className="item"
              key={url}
            >
              <MaybeWrap
                condition={isEditMode}
                wrap="div"
                className="item"
                key={url}
              >
                {showThumbnail && (
                  <div className="thumb">
                    <Image
                      item={item}
                      imageField={item.image_field}
                      alt=""
                      loading="lazy"
                      responsive={true}
                    />
                  </div>
                )}

                <div className="content">
                  {head_title && (
                    <div className="list-head-title">
                      <span>{head_title}</span>
                    </div>
                  )}
                  <div
                    className={cx('title', {
                      [`review-state-${review_state}`]: review_state,
                    })}
                  >
                    {title ? title : id}
                  </div>
                  <DateInfo
                    properties={item}
                    hideModifiedDate
                    hidePublishedLabel
                    hideReviewState
                  />
                  <div className="description">{description}</div>
                </div>
              </MaybeWrap>
            </ConditionalLink>
          );
        })}
      </div>

      {link && <div>{link}</div>}
    </>
  );
};

DefaultTemplate.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  linkMore: PropTypes.any,
  isEditMode: PropTypes.bool,
  showThumbnail: PropTypes.bool,
  showDownloadButton: PropTypes.bool,
};

export default DefaultTemplate;
